import type { QuestionPlace } from "../types/question.types";

/**
 * Where a question was raised from — stored on the question as `question_from_place`.
 *
 * Lives here rather than next to the ask-question modal because the admin question list, the
 * profile list and the place filters all need it, and importing it from the modal pulled that
 * modal's whole dependency graph (DOMPurify, the Rive player) into their chunks.
 */
export const QUESTION_PLACE = {
	HOME: "home",
	REQUEST_MENTOR: "request_mentor",
	COURSE: "course",
	BIBLE: "bible",
	FEEDBACK: "feedback",
	ABOUT: "about",
} as const;

/**
 * The one placeholder row in `question_bible_verses` that stands for "no verse picked yet".
 *
 * A shared contract with `added_bible_verse`, which renders its empty state on `verseInfo === 1`;
 * the lesson editor relies on the same value, so it is named rather than replaced.
 */
export const EMPTY_VERSE_SLOT = 1;

/**
 * Places a question list names above the question text. `home` and `about` have no label — a
 * question raised there is shown with its date alone.
 */
const PLACES_WITH_LABEL: readonly string[] = [
	QUESTION_PLACE.BIBLE,
	QUESTION_PLACE.REQUEST_MENTOR,
	QUESTION_PLACE.COURSE,
	QUESTION_PLACE.FEEDBACK,
];

export const hasQuestionPlaceLabel = (place?: QuestionPlace | string): boolean =>
	!!place && PLACES_WITH_LABEL.includes(place);

/** Recipient id for the support team — not a real user, resolved by the backend. */
export const TECH_SUPPORT_RECIPIENT_ID = "tech_support";

export const MAX_QUESTION_LENGTH = 1000;
